<div class="contact-container">
  <div class="flex flex-col gap-0 contact-card">
    <div class="public-forms-header mb-3">
      <a href="https://www.brandshelter.com">
        <img i18n-alt="contact form|Logo image alt text" alt="Logo" [src]="logoUrl()">
      </a>
    </div>

    <div class="p-4">
      <form [formGroup]="form" class="flex flex-col gap-5" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-1">
          <label for="first-name" i18n="contact form|First name field label">First name</label>
          <input pInputText [pAutoFocus]="true" id="first-name" formControlName="firstname"/>
          @let firstNameControl = form.get('firstname');
          @if (firstNameControl?.touched && firstNameControl?.errors?.['required']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|First name required error">
              First name is required
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(firstNameControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        </div>

        <div class="flex flex-col gap-1">
          <label for="last-name" i18n="contact form|Last name field label">Last name</label>
          <input pInputText id="last-name" formControlName="lastname"/>
          @let lastNameControl = form.get('lastname');
          @if (lastNameControl?.touched && lastNameControl?.errors?.['required']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|Last name required error">
              Last name is required
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(lastNameControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        </div>

        <div class="flex flex-col gap-1">
          <label for="email" i18n="contact form|Email field label">Email</label>
          <input pInputText id="email" type="email" formControlName="email"/>
          @let emailControl = form.get('email');
          @if (emailControl?.touched && emailControl?.errors?.['required']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|Email required error">
              Email is required
            </p-message>
          }
          @if (emailControl?.touched && emailControl?.errors?.['email'] && !emailControl?.errors?.['required']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|Email invalid format error">
              Please enter a valid email address
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(emailControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        </div>

        <div class="flex flex-col gap-1">
          <label for="phone" i18n="contact form|Phone field label">Phone</label>
          <input pInputText id="phone" formControlName="phone"/>
          @let phoneControl = form.get('phone');
          @if (phoneControl?.touched && phoneControl?.errors?.['pattern']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|Phone invalid format error">
              Please enter a valid phone number
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(phoneControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        </div>

        <div class="flex flex-col gap-1">
          <label for="message" i18n="contact form|Message field label">Message</label>
          <textarea pTextarea id="message" formControlName="message" rows="6"></textarea>
          @let messageControl = form.get('message');
          @if (messageControl?.touched && messageControl?.errors?.['required']) {
            <p-message severity="error" variant="simple" size="small" i18n="contact form|Message required error">
              Message is required
            </p-message>
          }
          @for (remoteMessage of getRemoteValidationMessages(messageControl); track remoteMessage) {
            <p-message severity="error" variant="simple" size="small">
              {{ remoteMessage }}
            </p-message>
          }
        </div>

        <div class="flex flex-col gap-1">
          <ngx-turnstile
            [siteKey]="turnstileSiteKey"
            (resolved)="onCaptchaResolved($event)"
            theme="light"
            size="normal">
          </ngx-turnstile>
        </div>

        <p-button type="submit" [disabled]="submitted || !form.valid || !form.dirty || !captchaToken" i18n="contact form|Submit button">Submit</p-button>
      </form>
    </div>
  </div>

  <app-footer-links></app-footer-links>
</div>
